function backBtn () {
    const backBtn = document.querySelector('.back-btn');

    if(backBtn) {
        backBtn.addEventListener('click', (e)=> {
            e.preventDefault();
            history.back();
        });
    }
}

export default backBtn;